// Add your custom JS here.

// Scroll up button
const toggleScrollToTop = document.querySelector("#back-to-top");

function toggleScrollButton() {
  toggleScrollToTop.style.display = window.scrollY > window.innerHeight / 4 ? "block" : "none";
}

toggleScrollButton();

window.addEventListener('scroll', toggleScrollButton);

toggleScrollToTop.addEventListener("click", function () {
  window.scrollTo(0, 0);
});



// Gsap animation
jQuery(document).ready(function($) {

  // initialize gsap
  const gsap = window.gsap;

  // get all the elements to animate
  const elements = document.querySelectorAll('.animate');

  // loop through each element and create an animation
  elements.forEach(element => {
    gsap.fromTo(element, {
      opacity: 0,
      y: 100,
    }, {
      opacity: 1,
      y: 0,
      duration: 1,
      delay: 0.3, // add a delay of 0.5 seconds
      ease: 'power2.out',
      scrollTrigger: {
        trigger: element,
        start: 'top bottom-=100',
      }
    });
    });
});

